module.exports = __webpack_public_path__ + "cd5167d2453590c4d9f1d0a2a02d3c9e.woff2";